import { GaNotifications } from '@ga/ui-components/notifications'

// @vue/component
export default {
  name: 'ga-notifications',

  components: {
    GaNotificationsBase: GaNotifications,
  },

  setup: () => {
    const position = 'center top'

    return {
      position,
    }
  },
}
